<template>
  <div class="">
    <div>

      <!-- --kiosk-printing   -->

      <div class="col  mb-3 mt-5">


        <div class="container d-print-none ">

          <i @click="printPage()" class="bi bi-printer h1 custom-pointer-print-icon"/>
          <i @click="printUserInfo()" class="h1 bi bi-card-text mx-4 custom-pointer-print-icon"/>
          <div class="d-print-none d-inline-block" v-if="sidebarData">
            <template v-if=" sidebarData.status && sidebarData.status.status_id == 0 &&  sidebarData.order_type == 3">

              <!-- Button trigger modal -->
              <button type="button" class="btn btn-primary d-inline-block" data-toggle="modal" data-target="#pay_modal">
                پرداخت
              </button>

              <!-- Modal -->
              <div class="modal fade" id="pay_modal" tabindex="-1" aria-labelledby="pay_modalLabel"
                   aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body">
                      <form @submit.prevent="submit">

                        <m-gate-manager1 v-model="selectedGate" :requiredInputs="true"/>


                        <div class="row my-3 text-center">
                          <div class="w-100">
                            <button :disabled="payButtonStatus" type="submit" class="btn px-5 btn-primary">پرداخت
                            </button>
                          </div>
                        </div>


                      </form>
                    </div>


                  </div>
                </div>
              </div>


            </template>
          </div>
        </div>

        <div class="text-center d-print-none">
          <h3 class="base-font-size print-mode-2">{{ pageTitle }}</h3>
        </div>


        <div v-if="Object.keys(sidebarData).length > 0" class="container invoice-container">
          <div class="row invoice-header mb-3 align-items-center">

            <div class="col-6 ">
              <img class="factor-3-logo" :src="findAttributeOnSiteInfo('icon')[0]"
                   :alt="findAttributeOnSiteInfo('site_name')[0]">
              <span class="mx-1">{{ findAttributeOnSiteInfo('site_name')[0] }}</span>
            </div>

            <div class="col-6">
              <h6>تاریخ فاکتور:
                <span dir="ltr">{{ dateConverter(sidebarData.created_at, '/', true) }}</span>
              </h6>
            </div>


            <div class="col-6 ">
              <h6>شماره فاکتور:
                {{ sidebarData.id }}
              </h6>
            </div>

            <div class="col-6 ">
              <h6>
                {{$t(`factor.order_delivery_code.shipment_code_label`)}}:
                {{ sidebarData.shipment_code }}
              </h6>
            </div>

          </div>

          <div class="row">
            <div class="col-12">
              <h6>خریدار:
                {{ sidebarData.user.name }} {{ sidebarData.user.last_name }}
              </h6>
            </div>
            <div class="col-12">
              <h6>کدملی:
                {{ sidebarData.user.meli_code }}
              </h6>
            </div>
            <div class="col-12">
              <h6>تلفن همراه:
                {{ sidebarData.user.cellphone }}
              </h6>

            </div>
            <div class="col-12 my-2">
              <h6>آدرس خریدار:

                <template v-if="sidebarData.address">
                <span v-if="sidebarData.address.default_address == 0">
                  {{ sidebarData.address.province.name }}
                  {{ sidebarData.address.city.name }}
                  {{ sidebarData.address.address }}
                  <template v-if="sidebarData.address.postal_code">({{ sidebarData.address.postal_code }})</template>
                  </span>
                  <span v-else>{{ sidebarData.address.address }}</span>
                  <span v-if=" sidebarData.address.description ">({{ sidebarData.address.description }})</span>
                </template>

              </h6>
            </div>
          </div>

          <div class="row">
            <div class="col-12">

              <table class="table table-bordered invoice-table table-responsive-md table-responsive-sm">
                <thead>
                <tr>
                  <th>ردیف</th>
                  <th>نام بار</th>
                  <th>تعداد</th>
                  <th>قیمت واحد</th>
                  <th>تخفیف واحد</th>
                  <th>قیمت کل</th>
                  <th>قیمت با تخفیف</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in sidebarData.items">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    <router-link class="text-decoration-none font-weight-bolder text-dark product-name"
                                 :to="{ name: 'Product', params: { name: item.product.raw_link } }">
                      {{ productName(item.product, item.sub_product) }}
                    </router-link>

                    <div class="factor-7-product-features mt-2" v-if="showProductFeatures">

                      <p class="p-0 m-0 factor-7-product-feature-item"
                         v-for="productFeature in productTableFeature(item.product)">
                        {{ productFeatureName(item.product, productFeature.id) }}:
                        {{ productFeatureValue(item.product, productFeature.id) }}
                      </p>
                    </div>

                  </td>
                  <td>
                    {{ item.quantity }}
                  </td>
                  <td v-html="$t('price.price', {currency: formatNumber(parseInt(item.price))})">

                  </td>
                  <td v-html="$t('price.price', {currency: formatNumber(item.offer_on_product)})">
                  </td>
                  <td v-html="$t('price.price', {currency: formatNumber(item.quantity*item.price)})">
                  </td>
                  <td v-html="$t('price.price', {currency: formatNumber(item.subtotal)})">
                  </td>
                </tr>

                <tr>
                  <td colspan="6">جمع کل</td>
                  <td v-html="$t('price.price', {currency: formatNumber(orderPriceWithoutTax(sidebarData))})">
                  </td>
                </tr>

                <tr>
                  <td colspan="6">
                    <span v-t="`factor.tax`"></span>
                    {{ findAttributeOnSiteInfo('tax')[0] }} %
                  </td>
                  <td v-html="$t('price.price', {currency: formatNumber(calculateTaxOnPrice(sidebarData))})">
                  </td>
                </tr>

                <tr>
                  <td colspan="6">جمع قابل پرداخت</td>
                  <td v-html="$t('price.price', {currency: formatNumber(parseInt(sidebarData.paying_amount))})">
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row invoice-footer">
            <div class="col-6">
              <h6>امضاء خریدار :</h6>
            </div>
            <div class="col-6 text-right">
              <h6>مهر فروشنده:</h6>
            </div>
          </div>
        </div>


      </div>


    </div>

  </div>


</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber, dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import TransactionInfo from "../FactorGeneralInfo/TransactionInfo/TransactionInfo1";
import mA from '../../Tags/A'
import mGateManager1 from "../../Gate/GateManager/GateManager1.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {
  productFeatureName, productFeatureValue,
  productName,
  productTableFeature
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "Factor4",
  components: {TransactionInfo, mA, mGateManager1},
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getUserOrderPaidItems",
      transactionInfo: "Transaction/getTransaction",
      sidebarData: "Transaction/getFactor",
      loading: "Loading/loadingStatus"
    }),
    pageTitle() {
      return (this.sidebarData.transaction != null || (this.sidebarData.loan_transaction != null && this.sidebarData.loan_transaction.length != 0)) ? this.$t('factor.factor') : this.$t('factor.pre_factor')
    },

  },
  props: {
    showProductFeatures: {
      default: false
    }
  },
  data() {
    return {
      selectedGate: '',
      payButtonStatus: false,
    }
  },
  methods: {
    productFeatureValue,
    productFeatureName,
    productTableFeature,
    productName,
    findAttributeOnSiteInfo,
    printPage() {
      const printMode2 = document.querySelectorAll('.print-mode-2')

      printMode2.forEach(item => {
        item.classList.remove('d-print-none')
      })

      window.print();
    },
    printUserInfo() {
      const printMode2 = document.querySelectorAll('.print-mode-2')

      printMode2.forEach(item => {
        item.classList.add('d-print-none')
      })

      window.print();
    },
    formatNumber,
    dateConverter,
    async submit() {
      this.payButtonStatus = true
      let order = this.sidebarData.id
      let gate = this.selectedGate

      let createTransaction = await this.$store.dispatch('Transaction/createTransaction', {
        order,
        gate
      })


    },
    extractDataFromOrderDescription(key) {
      let orderDescription = this.sidebarData.description

      try {
        orderDescription = JSON.parse(orderDescription)

        return orderDescription[key]
      } catch (e) {
        return ''
      }


    },
    setFactorData(req) {
      req.then(async (res) => {
        const response = await res.data.data;
        await this.$store.commit("ShoppingCart/setSidebarBasketData", response);
        await this.$store.commit("Transaction/setFactor", response);
        await this.$store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
        await this.$store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
        if (response.transaction == undefined) {
          await this.$store.commit("Transaction/setTransaction", response.loan_transaction);
        } else {
          await this.$store.commit("Transaction/setTransaction", response.transaction);
        }
      })
    },
    orderPriceWithoutTax(order) {
      let result = 0;
      order.items.forEach(item => {
        result += item.subtotal
      })

      return result
    },
    calculateTaxOnPrice(order) {
      let rawPrice = this.orderPriceWithoutTax(order);
      return order.paying_amount - rawPrice
    }
  },
  async mounted() {

    let orderId;
    let req;

    let pageName = this.$route.name;


    /*
    *
    *
    * NOTE
    *  MAKE ONE OF THE CONDITION BELOW `TRUE`
    *
    *
    *
    * */


    if (pageName == 'FactorWithSlug') {
      orderId = process.env.NODE_ENV != 'development' ? this.$route.params.slug : 'n4w3w2x1j0'
      req = this.$store.dispatch('Transaction/showOrderDetail', orderId)
    }
    if (pageName == 'Factor' ) {
      orderId = process.env.NODE_ENV != 'development' ? this.$route.params.orderId : 9
      req = this.$store.dispatch('Transaction/autoPrintShowTransactionDetail', orderId)
    }
    if (pageName == 'verifyTransaction') {
      const slug = process.env.NODE_ENV != 'development' ? this.$route.params.slug : 'm5m5n8j0g2'
      req = this.$store.dispatch("Transaction/verifyTransactionWithoutState", slug)
    }

    this.setFactorData(req)

  },
  watch: {
    loading(newValue, oldValue) {
      if (oldValue == true) {
        // add time out to make some time for loadign hide in page.
        setTimeout(() => {
          if (this.$route.query.print === 'on') {
            this.printPage()
          }
        }, 1_000)
      }
    }
  }
};
</script>

<style scoped>
.invoice-container {
  border: 1px solid #000;
  padding: 20px;
  margin: auto;
}

.invoice-header, .invoice-footer {
  margin: 20px 0 50px 0;
}

.invoice-header {
  border-bottom: 1px solid #000;
}

.invoice-table th, .invoice-table td {
  border: 1px solid #000;
  text-align: center;
}

.description {
  font-size: 12px;
  line-height: 1.2;
}

.factor-terms {
  font-weight: bolder;
}

@page {
  margin: 0;
}

@media print {
  .table-responsive-md, .table-responsive-sm {
    display: table;
  }
}

.factor-3-logo {
  height: 75px;
}

.signature {
  margin: -10px -48px 0 0;
  height: 150px;
}

</style>